export default __webpack_public_path__ + "static/media/4_zvuk.15d650d1.wav";